{
  "de": {
    "marketplace_partner": {
      "contact_me": {
        "button": "Kontaktieren Sie mich!",
        "failure": "Ein unerwarteter Fehler ist aufgetreten.",
        "success": "Wir werden uns in Kürze bei Ihnen melden."
      }
    }
  }
}
